import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";
import formatZdate from "../../../utils/formatZdate";

import MasterBrokerEditForm from "./MasterBrokerEditForm";

const getBrokerOneAPI = `${process.env.REACT_APP_API_URL}api/broker`;

const MasterBrokerEdit = ({ buttonConfig, selectedItemId, isButtonClicked }) => {
  const [brokerLogoName, setBrokerLogoName] = useState("");

  const schema = z.object({
    name: z.string().nonempty("Name is required."),
    short_name: z.string(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
    address_line_1: z.string().nonempty(),
    address_line_2: z.string(),
    // address_line_3: z.string().or(z.undefined()),
    city: z.string().nonempty("City name is required."),
    state: z.string().nonempty("State name is required."),
    pin_code: z.string().nonempty("Pincode name is required."),
    broker_logo: z.instanceof(FileList),
    broker_api: z.string(),
  });

  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
    ? sessionStorage.getItem("subscriberToken")
    : sessionStorage.getItem("token")}`,
    "Content-Type": "application/json",
  };

  const form = useForm({
    defaultValues: async () => {
      const getSegment = `${getBrokerOneAPI}/${selectedItemId}`;
      const res = await axios.get(getSegment, { headers });
      const segment = res.data.data;
      console.log(segment);
      setBrokerLogoName(segment?.broker_logo?.split("/"));

      return {
        name: segment.name,
        short_name: segment.short_name,
        status: segment.status ? "true" : "false",
        eff_start_date: segment.eff_start_date,
        eff_end_date: segment.eff_end_date,

        address_line_1: segment.address_line_1,
        address_line_2: segment.address_line_2,
        address_line_3: segment.address_line_3,
        city: segment.city,
        state: segment.state,
        pin_code: String(segment.pin_code),
        broker_logo: segment.broker_logo,
        broker_api: segment.broker_api,
      };
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterBrokerEditForm
      form={form}
      segmentName={buttonConfig.name}
      editHandler={buttonConfig.editHandler}
      closeHandler={buttonConfig.closeEditModal}
      selectedItemId={selectedItemId}
      brokerLogoName={brokerLogoName}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterBrokerEdit;
